import { useContext } from "react"
import { EditorToolbarButton, EditorToolbarTray } from "./EditorToolbarUI";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const EditorTextAlignTray = ({context}) => {
    const { editor, editorState } = useContext(context);

    return (
        <EditorToolbarTray>
            <EditorToolbarButton
                icon={<MaterialIcon name='format_align_left' weight={300}/>}
                onClick={() => editor.commands.unsetTextAlign()}
                active={editorState.currentAlignment === 'left'}
            />
            <EditorToolbarButton
                icon={<MaterialIcon name='format_align_right' weight={300}/>}
                onClick={() => editor.chain().focus().setTextAlign('right').run()}
                active={editorState.currentAlignment === 'right'}
            />
            <EditorToolbarButton
                icon={<MaterialIcon name='format_align_center' weight={300}/>}
                onClick={() => editor.chain().focus().setTextAlign('center').run()}
                active={editorState.currentAlignment === 'center'}
            />
            <EditorToolbarButton
                icon={<MaterialIcon name='format_align_justify' weight={300}/>}
                onClick={() => editor.chain().focus().setTextAlign('justify').run()}
                active={editorState.currentAlignment === 'justify'}
            />
        </EditorToolbarTray>
    )
}






                    